export const dashboardTabsList = { policies: "Type de places", onStreet: "Voies" };
